import { Clock, Video, Copy, CheckCircle } from "lucide-react";

export default function JoinCallSection({ slotData, copiedLink, copyToClipboard }) {
  if (!slotData.meeting_link) {
    return (
      <div className="bg-background rounded-lg border border-secondary-border p-6 text-center">
        <Clock className="mx-auto h-12 w-12 text-primary mb-4" />
        <h4 className="text-base font-semibold text-foreground mb-2">
          Call Link Not Ready Yet
        </h4>
        <p className="text-sm text-muted-foreground mb-4">
          Your interviewer is still preparing the call link.
        </p>
        <p className="text-xs text-muted-foreground">
          You&apos;ll receive an email notification once the call link is available. You can also check back here for updates.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-background rounded-lg border border-secondary-border p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex-1">
          <h4 className="text-base font-semibold text-foreground mb-2">
            Ready to Join Your Call
          </h4>
          <p className="text-sm text-muted-foreground">
            Your session is ready. Click the button below to join your call.
          </p>
        </div>
        <button
          onClick={() => copyToClipboard(slotData.meeting_link)}
          className="flex items-center px-3 py-2 bg-secondary border border-secondary-border rounded-md hover:bg-background transition-colors text-sm"
        >
          {copiedLink ? (
            <>
              <CheckCircle className="h-4 w-4 mr-1" />
              Copied
            </>
          ) : (
            <>
              <Copy className="h-4 w-4 mr-1" />
              Copy Link
            </>
          )}
        </button>
      </div>
      
      <div className="flex items-center space-x-4">
        <a
          href={slotData.meeting_link}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors font-medium"
        >
          <Video className="h-5 w-5 mr-2" />
          Join Call
        </a>
        <div className="text-xs text-muted-foreground">
          <p>Join 5-10 minutes early</p>
          <p>Test your audio and video</p>
        </div>
      </div>
    </div>
  );
} 